module.exports = __webpack_public_path__ + "images/card-templates/header-card-template.fe6b956f1fe253d0e4c9.png";